import { deleteDoc, doc } from "firebase/firestore";
import { deleteObject, ref } from "firebase/storage";
import { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Carousel,
  Col,
  Container,
  Row,
  Stack,
} from "react-bootstrap";
import { toast } from "react-toastify";
import background from "../assets/logo/logo_transparent.png";
import { database, storage } from "../firebase";
import useDatabase from "../hooks/useDatabase";
import CreateItemModal from "./CreateItemModal";
import ViewImagesModal from "./ViewImagesModal";

export default function CardGrid({
  loading,
  setLoading,
  setSelectedItem,
  setShowView,
  uid,
  category,
  isPrivate,
}) {
  const { docs } = useDatabase("soccer", uid, category);

  const [showAlert, setShowAlert] = useState(false);
  const [file, setFile] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showImages, setShowImages] = useState(false);
  const [carousel, setCarousel] = useState(null);

  const showToast = (message, type) => {
    const options = { type: type };
    toast(message, options);
  };

  const toTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const deleteItem = (file) => {
    for (var i = 0; i < file.image_urls.length; ++i) {
      const pictureRef = ref(storage, file.image_urls[i]);

      // Delete the pictures in Storage
      deleteObject(pictureRef)
        .then(() => {
          // File deleted successfully
        })
        .catch((err) => {
          console.error(err);
          showToast("Fehler beim Löschen aufgetreten!", toast.TYPE.ERROR);
        });
    }

    deleteDoc(doc(database, "soccer", file.id)).then(() => {
      showToast("Löschen erfolgreich.", toast.TYPE.SUCCESS);
    });

    setShowAlert(false);
  };

  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "80%",
        minHeight: "100vw",
      }}
    >
      <Alert show={showAlert} variant="primary">
        <Alert.Heading className="ms-3">
          Willst du den Artikel wirklich löschen?
        </Alert.Heading>
        <Button
          className="mt-2 ms-3"
          style={{ marginRight: "30px", width: "60px" }}
          onClick={() => deleteItem(file)}
          variant="outline-success"
        >
          Ja
        </Button>

        <Button
          className="mt-2"
          style={{ width: "60px" }}
          onClick={() => setShowAlert(false)}
          variant="outline-danger"
        >
          Nein
        </Button>
      </Alert>
      <div className="pt-sm-5 pt-4 d-flex justify-content-center">
        {docs && docs.length === 0 ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
              margin: "5% 20% 5% 20%",
              height: "100%",
            }}
          >
            <h1 className="d-flex flex-column" style={{ textAlign: "center" }}>
              Noch keine Artikel vorhanden!
            </h1>
            <hr></hr>
            <h4 className="d-flex flex-column" style={{ textAlign: "center" }}>
              {isPrivate
                ? "Lade einen Artikel hoch!"
                : "Sei der Erste und lade einen Artikel hoch!"}
            </h4>
          </div>
        ) : (
          <Container className="d-flex justify-content-center align-items-start mb-3">
            <Row xs={1} md={2} lg={3} className="g-sm-5 g-4 w-100">
              {docs &&
                docs.map((doc) => (
                  <Col key={doc.id}>
                    <Card
                      style={{
                        borderRadius: "25px",
                      }}
                    >
                      <Card.Body style={{ padding: "0%", margin: "0%" }}>
                        <Carousel variant="light" interval={null} fade>
                          {doc.image_urls &&
                            doc.image_urls.map((url) => (
                              <Carousel.Item
                                key={url.slice(url.lastIndexOf("=") + 1)}
                                onClick={() => {
                                  setShowImages(true);
                                  setCarousel(doc.image_urls);
                                }}
                              >
                                <img
                                  style={{
                                    padding: "0%",
                                    borderRadius: "25px 25px 0% 0%",
                                  }}
                                  className="d-block w-100"
                                  src={url}
                                  alt="slide"
                                />
                              </Carousel.Item>
                            ))}
                        </Carousel>
                        <Stack className="my-3 justify-content-center">
                          <Card.Title
                            className="d-flex justify-content-center"
                            as="h4"
                          >
                            {doc.title}
                          </Card.Title>
                          <hr
                            className="mb-4 mt-2"
                            style={{
                              color: "currentColor",
                              height: "5px",
                              width: "70%",
                              margin: "auto",
                              borderRadius: "25px",
                            }}
                          ></hr>

                          <Stack
                            direction="horizontal"
                            className="d-flex justify-content-between mx-3 mx-lg-4"
                          >
                            <Col
                              className="d-flex justify-content-start"
                              style={{ padding: "0 15px 0 0" }}
                            >
                              <Card className="w-100">
                                <Card.Header
                                  className="d-flex justify-content-center"
                                  style={{
                                    backgroundColor: "#FFD700",
                                  }}
                                >
                                  Preis
                                </Card.Header>
                                <Card.Body className="d-flex justify-content-center">
                                  {doc.price} €
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col
                              className="d-flex justify-content-end"
                              style={{ padding: "0 0 0 15px" }}
                            >
                              <Card className="w-100">
                                <Card.Header
                                  className="d-flex justify-content-center"
                                  style={{
                                    backgroundColor: "#FFD700",
                                  }}
                                >
                                  Größe
                                </Card.Header>
                                <Card.Body className="d-flex justify-content-center">
                                  {doc.size}
                                </Card.Body>
                              </Card>
                            </Col>
                          </Stack>

                          <Row className="d-flex justify-content-center mt-4 mb-2 mx-3 mx-lg-4">
                            {uid ? (
                              <div
                                className="d-flex justify-content-between"
                                style={{ padding: "0px" }}
                              >
                                <Button
                                  variant="outline-danger"
                                  onClick={() => {
                                    toTop();
                                    setShowAlert(true);
                                    setFile(doc);
                                  }}
                                >
                                  <Row>
                                    <Col className="d-flex align-items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z" />
                                      </svg>
                                    </Col>
                                    <Col
                                      className="d-sm-block d-lg-none d-xl-block d-xxl-block"
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <div style={{ whiteSpace: "nowrap" }}>
                                        Löschen
                                      </div>
                                    </Col>
                                  </Row>
                                </Button>

                                <Button
                                  variant="outline-success"
                                  onClick={() => {
                                    setShowCreate(true);
                                    setFile(doc);
                                  }}
                                >
                                  <Row>
                                    <Col className="d-flex align-items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                                      </svg>
                                    </Col>
                                    <Col
                                      className=""
                                      style={{ paddingLeft: "0px" }}
                                    >
                                      <div style={{ whiteSpace: "nowrap" }}>
                                        Bearbeiten
                                      </div>
                                    </Col>
                                  </Row>
                                </Button>
                              </div>
                            ) : (
                              <Button
                                style={{ width: "100%" }}
                                variant="primary"
                                onClick={() => {
                                  setSelectedItem(doc);
                                  setShowView(true);
                                }}
                              >
                                Mehr Infos
                              </Button>
                            )}
                          </Row>
                        </Stack>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
            </Row>
          </Container>
        )}
        <CreateItemModal
          edit={true}
          file={file}
          showCreate={showCreate}
          setShowCreate={setShowCreate}
          loading={loading}
          setLoading={setLoading}
        />
        {window.screen.width > 767 ? (
          <ViewImagesModal
            showImages={showImages}
            setShowImages={setShowImages}
            carousel={carousel}
            setCarousel={setCarousel}
          />
        ) : (
          <></>
        )}
        <div className="mb-5"></div>
      </div>
    </div>
  );
}
